import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-down-arrow-accent",
  "use": "ic-down-arrow-accent-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"ic-down-arrow-accent\">\n    <path fill=\"#03ADEF\" fill-rule=\"evenodd\" d=\"M6.207 7h5.586a.5.5 0 0 1 .353.854l-2.792 2.792a.5.5 0 0 1-.708 0L5.854 7.854A.5.5 0 0 1 6.207 7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol